module.exports = __webpack_public_path__ + "b5ced615aa12014db4706086b5975f71.svg";